function ContactScreen() {

    return (
        <div className="container">
            <br />
            You can contact with me via Email <br />
            Contact: omerbyrk8@gmail.com
        </div>
    );
}

export default ContactScreen;